import React from "react";
import { iconName, Icon } from "../icons/Icons";
import { Flex } from "./FlexHelpers";

// TODO: demo in design system page

type StatusCounterProps = {
    icon:iconName,
    iconColor:string
    text:string,
    count:number
}
export function StatusCounter(props:StatusCounterProps):JSX.Element
{
    return (
        props.count === 0 
        ? <></> 
        :<Flex flexDirection="row" alignItems="center" gap={4}>
            <Icon name={props.icon} color={props.iconColor} size="small"/>
            <span style={{fontSize:'12px'}}>{props.count} {props.text}</span>
        </Flex>        
    );
}